"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * 校园收益联盟（商户端）。
 *
 * 后端是独立的 tjMall-alliance 模块，与商城淘客不是同一套账，
 * 所以单独一级菜单，不并进 distribution 里，免得两边的「佣金」被当成一回事。
 */
var allianceRouter = {
  path: '/alliance',
  component: _layout.default,
  redirect: '/alliance/overview',
  name: 'Alliance',
  meta: {
    title: '收益联盟',
    icon: 'clipboard'
  },
  children: [{
    path: 'overview',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/overview/index'));
      });
    },
    name: 'AllianceMerchantOverview',
    meta: {
      title: '经营概览',
      icon: ''
    }
  }, {
    path: 'verify',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/verify/index'));
      });
    },
    name: 'AllianceVerifyDesk',
    meta: {
      title: '核销台',
      icon: ''
    }
  }, {
    path: 'code',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/code/index'));
      });
    },
    name: 'AllianceMerchantCode',
    meta: {
      title: '商户码',
      icon: ''
    }
  }, {
    path: 'records',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/records/index'));
      });
    },
    name: 'AllianceVerifyRecords',
    meta: {
      title: '核销记录',
      icon: ''
    }
  }, {
    path: 'account',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/account/index'));
      });
    },
    name: 'AllianceMerchantAccount',
    meta: {
      title: '积分账户',
      icon: ''
    }
  }, {
    path: 'bills',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/alliance/bills/index'));
      });
    },
    name: 'AllianceMerchantBills',
    meta: {
      title: '账单中心',
      icon: ''
    }
  }]
};
var _default = exports.default = allianceRouter;